import React, { useMemo, useState } from 'react';
import { Button, Upload } from 'antd';
import { PlusCircleOutlined } from '@ant-design/icons';

const { Dragger } = Upload;

export default function UploadHydroTwinFilesStep({
  initialData,
  onNext,
  onBack,
  onCancel,
  loading = false,
}: any) {
  const [h5File, setH5File] = useState<File | null>(initialData?.h5File || null);
  const [hdhtFile, setHdhtFile] = useState<File | null>(initialData?.hdhtFile || null);

  const createUploadProps = useMemo(
    () => (accept: string, onSelect: (file: File) => void) => ({
      name: 'file',
      multiple: false,
      accept,
      showUploadList: false,
      beforeUpload: (file: File) => {
        onSelect(file);
        return false;
      },
    }),
    [],
  );

  const renderUploadArea = (
    title: string,
    accept: string,
    selectedFile: File | null,
    onSelect: (file: File) => void,
    buttonLabel: string,
  ) => (
    <div className="mb-4">
      <span className="mb-2 block">{title}</span>
      <Dragger {...createUploadProps(accept, onSelect)} style={{ padding: '12px' }}>
        <p className="ant-upload-drag-icon">
          <Button
            icon={<PlusCircleOutlined style={{ fontSize: '16px' }} rev={undefined} />}
            shape="round"
          >
            {buttonLabel}
          </Button>
        </p>
        <p className="ant-upload-hint">Drag and drop your {accept} file here</p>
        {selectedFile && <p className="mt-2">{selectedFile.name}</p>}
      </Dragger>
    </div>
  );

  return (
    <div className="flex column" style={{ height: '100%' }}>
      <div className="flex column">
        <span className="mt-2 mb-1 font-bold">Upload Files</span>
        <span className="mb-4">
          {initialData?.updateMode
            ? <>Upload one <b>.h5</b> file and one <b>.hdht</b> file to update this HydroTwin.</>
            : <>Upload one <b>.h5</b> file and one <b>.hdht</b> file for the new HydroTwin.</>}
        </span>

        {renderUploadArea('H5 file', '.h5', h5File, setH5File, 'Add H5 File')}
        {renderUploadArea('HDHT file', '.hdht', hdhtFile, setHdhtFile, 'Add HDHT File')}
      </div>

      <div className="flex mt-4 justify-end">
        <Button
          className="h-[40px]"
          onClick={() => {
            onCancel();
          }}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          className="ml-3 bg-[#00203C] text-white h-[40px]"
          onClick={() => {
            onNext({
              ...initialData,
              h5File,
              hdhtFile,
            });
          }}
          disabled={!h5File || !hdhtFile || loading}
          loading={loading}
        >
          OK
        </Button>
      </div>
    </div>
  );
}
